// packages/shared-components/src/components/Tabs/TabItem.tsx
import { TabItemProps } from "./types";

export function TabItem({ children }: TabItemProps) {
  return <>{children}</>;
}
